import styled from "@emotion/styled";

export const ZoomControlWrapper = styled.div`
  position: absolute;
  bottom: 32px;
  left: 16px;
  display: flex;
  flex-flow: column;
`;

export const ZoomControl = styled.button`
  width: 40px;
  height: 40px;
  background: ${(props) => props.theme.colors.snowdrop};
  border: none;
  padding: 0;
  position: relative;
`;

export const ZoomControlText = styled.span`
  color: ${(props) => props.theme.colors.charcoal};
  font-size: 40px;
  font-weight: 300;
  position: relative;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  line-height: 35px;
`;
